import React from 'react';
import { Card } from './card';

// Skeleton card for loading state
export const TaskCardSkeleton = ({ color = 'blue' }) => {
  const borderColor = color === 'emerald' ? 'border-l-emerald-300' : color === 'orange' ? 'border-l-orange-300' : 'border-l-blue-300';
  
  return (
    <Card className={`p-4 border-l-4 ${borderColor} animate-pulse`}>
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-slate-200 rounded" />
          <div className="w-24 h-4 bg-slate-200 rounded" />
        </div>
        <div className="w-12 h-5 bg-slate-200 rounded" />
      </div>
      <div className="space-y-2 mb-2">
        <div className="w-full h-3 bg-slate-200 rounded" />
        <div className="w-3/4 h-3 bg-slate-200 rounded" />
      </div>
      <div className="flex items-center gap-1">
        <div className="w-3 h-3 bg-slate-200 rounded" />
        <div className="w-32 h-3 bg-slate-200 rounded" />
      </div>
      <div className="flex items-center justify-between mt-2 pt-2 border-t border-slate-100">
        <div className="w-24 h-3 bg-slate-200 rounded" />
        <div className="flex items-center gap-2">
          <div className="w-14 h-6 bg-slate-200 rounded" />
          <div className="w-4 h-4 bg-slate-200 rounded" />
        </div>
      </div>
    </Card>
  );
};

// Multiple skeleton cards
export const TaskListSkeleton = ({ count = 5, color = 'blue' }) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <TaskCardSkeleton key={i} color={color} />
      ))}
    </div>
  );
};

export default TaskCardSkeleton;
